/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type Currency = "AUD" | "CAD" | "CHF" | "EUR" | "GBP" | "JPY" | "MXN" | "USD" | "%future added value";
export type DesignProfileStatus = "ACTIVE" | "DELETED" | "NEW" | "PENDING" | "%future added value";
export type TradeFirmSalesTier = "P_AND_M" | "TIER_1" | "TIER_2" | "TIER_3" | "TIER_4" | "UNKNOWN" | "%future added value";
export type initializeTrackingQueryVariables = {
    readonly hasUserId: boolean;
    readonly userId: string;
    readonly userIds?: ReadonlyArray<string> | null;
};
export type initializeTrackingQueryResponse = {
    readonly viewer: {
        readonly submittedTransactions?: {
            readonly totalResults: number | null;
        } | null;
        readonly confirmedTransactionsMostRecent?: {
            readonly totalResults: number | null;
        } | null;
        readonly user?: {
            readonly createdDate: string | null;
            readonly firstSessionDate: string | null;
            readonly isTrade: boolean | null;
            readonly hasVipPermission: boolean | null;
            readonly authMetadata: {
                readonly emailOnly: boolean | null;
                readonly hasPassword: boolean | null;
            } | null;
            readonly profile: {
                readonly email: string | null;
                readonly zipCode: string | null;
                readonly currency: Currency | null;
            } | null;
            readonly serviceId: string | null;
            readonly totalMessagesToDealers: number | null;
            readonly tradeFirm: {
                readonly serviceId: string | null;
                readonly tier: TradeFirmSalesTier | null;
                readonly profileStatus: DesignProfileStatus | null;
                readonly rewards: {
                    readonly currentProgram: {
                        readonly programInfo: {
                            readonly code: string | null;
                        } | null;
                    } | null;
                } | null;
            } | null;
            readonly verifiedTradeStatus: string | null;
            readonly mentionMeTagParameters: {
                readonly ciphertext: string | null;
                readonly nonce: string | null;
            } | null;
        } | null;
    } | null;
};
export type initializeTrackingQuery = {
    readonly response: initializeTrackingQueryResponse;
    readonly variables: initializeTrackingQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "hasUserId",
            "type": "Boolean!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userId",
            "type": "String!",
            "defaultValue": null
        } as any),
        ({
            "kind": "LocalArgument",
            "name": "userIds",
            "type": "[String!]",
            "defaultValue": null
        } as any)
    ], v1 = ({
        "kind": "Variable",
        "name": "buyerId",
        "variableName": "userIds"
    } as any), v2 = ({
        "kind": "Literal",
        "name": "first",
        "value": 0
    } as any), v3 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "totalResults",
            "args": null,
            "storageKey": null
        } as any)
    ], v4 = ({
        "kind": "LinkedField",
        "alias": "submittedTransactions",
        "name": "transactions",
        "storageKey": null,
        "args": [
            (v1 /*: any*/),
            (v2 /*: any*/),
            {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.submitted"
            }
        ],
        "concreteType": "TransactionConnection",
        "plural": false,
        "selections": (v3 /*: any*/)
    } as any), v5 = ({
        "kind": "LinkedField",
        "alias": "confirmedTransactionsMostRecent",
        "name": "transactions",
        "storageKey": null,
        "args": [
            (v1 /*: any*/),
            (v2 /*: any*/),
            {
                "kind": "Literal",
                "name": "viewName",
                "value": "buyerTracking.confirmed"
            }
        ],
        "concreteType": "TransactionConnection",
        "plural": false,
        "selections": (v3 /*: any*/)
    } as any), v6 = [
        ({
            "kind": "Variable",
            "name": "userId",
            "variableName": "userId"
        } as any)
    ], v7 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "createdDate",
        "args": null,
        "storageKey": null
    } as any), v8 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "firstSessionDate",
        "args": null,
        "storageKey": null
    } as any), v9 = ({
        "kind": "ScalarField",
        "alias": "isTrade",
        "name": "hasPermission",
        "args": [
            {
                "kind": "Literal",
                "name": "name",
                "value": "B_VERIFIED_TRADE"
            }
        ],
        "storageKey": "hasPermission(name:\"B_VERIFIED_TRADE\")"
    } as any), v10 = ({
        "kind": "ScalarField",
        "alias": "hasVipPermission",
        "name": "hasPermission",
        "args": [
            {
                "kind": "Literal",
                "name": "name",
                "value": "B_VIP_CHECKOUT"
            }
        ],
        "storageKey": "hasPermission(name:\"B_VIP_CHECKOUT\")"
    } as any), v11 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "emailOnly",
        "args": null,
        "storageKey": null
    } as any), v12 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasPassword",
        "args": null,
        "storageKey": null
    } as any), v13 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "profile",
        "storageKey": null,
        "args": null,
        "concreteType": "Profile",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "email",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "zipCode",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "currency",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v14 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "serviceId",
        "args": null,
        "storageKey": null
    } as any), v15 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "totalMessagesToDealers",
        "args": null,
        "storageKey": null
    } as any), v16 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "tier",
        "args": null,
        "storageKey": null
    } as any), v17 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "profileStatus",
        "args": null,
        "storageKey": null
    } as any), v18 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "code",
        "args": null,
        "storageKey": null
    } as any), v19 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "verifiedTradeStatus",
        "args": null,
        "storageKey": null
    } as any), v20 = ({
        "kind": "LinkedField",
        "alias": null,
        "name": "mentionMeTagParameters",
        "storageKey": null,
        "args": null,
        "concreteType": "mentionMeTagParameters",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "ciphertext",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "nonce",
                "args": null,
                "storageKey": null
            }
        ]
    } as any), v21 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "initializeTrackingQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "authMetadata",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserExistsMetadataType",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v12 /*: any*/)
                                            ]
                                        },
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "tradeFirm",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TradeFirmType",
                                            "plural": false,
                                            "selections": [
                                                (v14 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "rewards",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TradeFirmRewards",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "currentProgram",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ParentProgram",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "programInfo",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "LoyaltyProgram",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v18 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ]
                                        },
                                        (v19 /*: any*/),
                                        (v20 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "initializeTrackingQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        (v21 /*: any*/),
                        {
                            "kind": "Condition",
                            "passingValue": true,
                            "condition": "hasUserId",
                            "selections": [
                                (v4 /*: any*/),
                                (v5 /*: any*/),
                                {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "user",
                                    "storageKey": null,
                                    "args": (v6 /*: any*/),
                                    "concreteType": "User",
                                    "plural": false,
                                    "selections": [
                                        (v7 /*: any*/),
                                        (v8 /*: any*/),
                                        (v9 /*: any*/),
                                        (v10 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "authMetadata",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "UserExistsMetadataType",
                                            "plural": false,
                                            "selections": [
                                                (v11 /*: any*/),
                                                (v12 /*: any*/),
                                                (v21 /*: any*/)
                                            ]
                                        },
                                        (v13 /*: any*/),
                                        (v14 /*: any*/),
                                        (v15 /*: any*/),
                                        {
                                            "kind": "LinkedField",
                                            "alias": null,
                                            "name": "tradeFirm",
                                            "storageKey": null,
                                            "args": null,
                                            "concreteType": "TradeFirmType",
                                            "plural": false,
                                            "selections": [
                                                (v14 /*: any*/),
                                                (v16 /*: any*/),
                                                (v17 /*: any*/),
                                                {
                                                    "kind": "LinkedField",
                                                    "alias": null,
                                                    "name": "rewards",
                                                    "storageKey": null,
                                                    "args": null,
                                                    "concreteType": "TradeFirmRewards",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "LinkedField",
                                                            "alias": null,
                                                            "name": "currentProgram",
                                                            "storageKey": null,
                                                            "args": null,
                                                            "concreteType": "ParentProgram",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "alias": null,
                                                                    "name": "programInfo",
                                                                    "storageKey": null,
                                                                    "args": null,
                                                                    "concreteType": "LoyaltyProgram",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        (v18 /*: any*/),
                                                                        (v21 /*: any*/)
                                                                    ]
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                },
                                                (v21 /*: any*/)
                                            ]
                                        },
                                        (v19 /*: any*/),
                                        (v20 /*: any*/),
                                        (v21 /*: any*/)
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "initializeTrackingQuery",
            "id": "ferrum/231.0.0-2019-09-03T18:20:59.170Z/initializeTrackingQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '26f22af53212468a4de3369e05f696a0';
export default node;
